<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';

withDefaults(defineProps<{
  url: string;
  mobileUrl?: string;
  alt: string;
  caption?: string;
  full?: boolean;
  wide?: boolean;
  centered?: boolean;
}>(), {
  full: false,
  wide: false,
});
</script>

<template>
  <ContentContainer
    class="image-container"
    :class="{ 'is-full': full }"
  >
    <ContentColumn
      class="image-wrap"
      :class="{ 'is-wide': wide, 'is-centered': centered }"
    >
      <figure :class="{ 'has-mobile': !!mobileUrl }">
        <NuxtImg
          class="image-desktop"
          :src="url"
          :alt="alt"
          width="1280"
        />
        <NuxtImg
          v-if="mobileUrl"
          class="image-mobile"
          :src="mobileUrl"
          :alt="alt"
          width="1280"
        />
        <figcaption v-if="caption" v-html="caption" />
      </figure>
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.image-container {
  margin-bottom: var(--spacing-m);

  &.is-full {
    :deep(.content-container) {
      @include screen.respond(tablet) {
        padding: 0;
      }
    }
  }
}
.image-wrap {
  &.is-wide {
    :deep(.column-main) {
      @include screen.grid(4 / span 8, 8, 4);
    }

    &.is-centered {
      :deep(.column-main) {
        @include screen.grid(3 / span 8, 8, 4);
      }
    }
  }

  .is-full & {
    :deep(.column-main) {
      @include screen.grid(12, 8, 4);
    }
  }
}

figure {
  margin: 0;
  padding: 0;

  img {
    width: 100%;
    height: auto;
  }

  .image-desktop {
    display: block;
  }
  &.has-mobile {
    .image-desktop {
      @include screen.respond(mobile) {
        display: none;
      }
    }
    .image-mobile {
      display: none;
      @include screen.respond(mobile) {
        display: block;
      }
    }
  }
}

figcaption {
  font-size: 1.4rem;
  margin-top: var(--spacing-ms);

  a {
    display: inline-flex;
    align-items: center;

    &:after {
      content: "";
      width: 1.4rem;
      height: 1.4rem;
      display: inline-block;
      background: url(@/icons/external-link.svg);
      margin-left: 1rem;
    }
  }
}
</style>
